const config = require("./config.json");
const APP_ENV = process.env.REACT_APP_ENV;
const envConfig = config[APP_ENV];

export const baseUri = envConfig?.API_BASE_URL;
export const s3baseUri = envConfig?.PIC_BASE_URL;
export const client_url = envConfig?.REACT_APP_CLIENT_URL;
export const xshKey = envConfig?.SSH_KEY;
export const project_mode = envConfig?.PROJECT_MODE;
export const web_url = envConfig?.WEB_URL;
